import { useEffect, useState } from "react";

import AuthenticatedContractDetails from "../../../pages/contract/authenticatedContractDetails/authenticatedContract";
import PublicContractDetails from "../../../pages/contract/publicContractDetails";
import { isLoggedIn } from "../authContext";
import { EVENT_LOCAL_STORAGE_LOGIN } from "../events";
const ContractRoute = () => {
  const [isAuth, setIsAuth] = useState<boolean>(isLoggedIn);
  useEffect(() => {
    window.addEventListener(EVENT_LOCAL_STORAGE_LOGIN, () => {
      setIsAuth(isLoggedIn());
    });
  }, [isLoggedIn()]);
  return isAuth ? (
    <AuthenticatedContractDetails />
  ) : (
    <div className="public-contract">
      <PublicContractDetails />
    </div>
  );
};

export default ContractRoute;
